<template>
  <div class="app-body">
    <Header></Header>
    <main class="container-fluid p-0 d-flex">
      <div class="row m-0">
        <div class="col-text col-text-banner col-sm-12 col-md-6  p-5 d-flex flex-column">
          <h1>Pricing Highlights</h1>
          <div class="flex-row mt-5">
            <i class="fa fa-fw fa-chevron-right"></i>
            <div>
              <div>Team owner is never charged</div>
              <div class="help-text">Every other active team member costs EUR&nbsp;1 per month.</div>
            </div>
          </div>
          <div class="flex-row mt-5">
            <i class="fa fa-fw fa-chevron-right"></i>
            <div>
              <div>Only active team members are charged</div>
              <div class="help-text">You can add as many people to your teams as you wish.
                We do not charge for adding people and do not charge for those who stay idle.
                We charge only for active team members.</div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-text-dark  p-5">
          <h4>Pricing Examples</h4>
          <p>GanttProject Cloud pricing is usage based. The details of pricing and billing are given in the
            <a class="inline-link" :href="routes.ABOUT_TOS">Terms of Service</a>.
            The examples given below provide an overview of what you may expect considering different usage scenarios.
          </p>

          <h5>Basic pricing rules</h5>
          <ol>
            <li>One credit is EUR&nbsp;1.</li>
            <li>Team owner is not charged.</li>
            <li>Every active team member, except for the owner, costs 1 credit per month.</li>
          </ol>

          <h5>Examples of the usage scenarios</h5>
          <ul class="pricing-use-cases">
            <li>You are the sole member of your team. This is free.</li>
            <li>You have a team of 5 active members, excluding you, who read and write projects daily.<br>
              This costs 5 credits.</li>
            <li>You have a team of 20 members, but only 5 of them, excluding you, have been active this month.<br>
              This costs 5 credits, because only active teammates are charged.</li>
            <li>You have 5 teams, and in every team there is a single active member, excluding you.<br>
              This costs 5x1=5 credits.</li>
            <li>You have 5 teams, and every team consists of 5 active members, excluding you.<br>
              This costs 5x5=25 credits.</li>
          </ul>
          <p class="help-text">Users who signed up before October 4, 2026 keep 1 free credit per team per month.</p>

          <h5>Credit price</h5>
          <div>While GanttProject Cloud is in beta testing, one credit point costs EUR 1 (one euro).
            Besides, everyone who signs up gets 2 credits for free to try GanttProject Cloud in a team.</div>
          <p class="help-text">Users who signed up before October 4, 2026 got 5 free credits.</p>

        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import Header from '@/components/Header.vue';

@Component({
  components: {Header}
})
export default class AboutPricing extends Vue {
  private routes = {
      ABOUT_TOS: "/about/tos#pricing",
  }
  private emails = {
      CONTACT: "contact@ganttproject.cloud"
  }
}
</script>

<style lang="scss">
@import 'sass/about_pricing';

</style>
